"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "How do you ensure our organization maintains full OSHA compliance?",
  answer: "We develop site-specific written safety plans based on your unique hazards and exposures, ensuring your operations meet or exceed all OSHA regulatory requirements and industry best practices."
}, {
  id: "faq-2",
  question: "What expertise do you offer in safety inspections and risk analysis?",
  answer: "We develop comprehensive safety inspection programs and conduct thorough risk analyses focused on employee protection, helping you identify and mitigate hazards before accidents occur."
}, {
  id: "faq-3",
  question: "Can you help improve pedestrian and site safety through hazard mitigation?",
  answer: "Yes. We design OSHA-compliant traffic control and hazard mitigation strategies tailored to your site to protect pedestrians and ensure safe movement throughout your facility."
}, {
  id: "faq-4",
  question: "Do you provide OSHA-approved training for hazardous materials handling?",
  answer: "Absolutely. We offer OSHA-approved training for hazardous materials handling and develop compliant safety programs that ensure your team understands proper containment and emergency protocols."
}];
export default function LogisticsFaq() {
  return <section data-section-id="74570" id="frequently-asked-questions" className="bg-background text-foreground py-24 px-6 md:px-8">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-sans text-[32px] font-extrabold text-primary mb-12 text-left uppercase tracking-tight">
          Safety & Compliance FAQ
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border border-b">
              <AccordionTrigger className="text-foreground hover:text-primary text-lg md:text-xl font-bold hover:no-underline transition-colors py-6 text-left font-sans">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-base md:text-lg leading-relaxed text-foreground/80 pb-8 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}